
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

import { ForuscareService } from '../foruscare/foruscare.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SharedService } from '../shared/shared.service';
import { Router } from '../../../../node_modules/@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpinterceptorService {
  public cookieservice: any;
  constructor(public router: Router, private cookieService: CookieService, private foruscareService: ForuscareService, private ngxService: NgxUiLoaderService, private sharedService: SharedService) {
    this.cookieservice = cookieService;
  }

  isAppointmentAPI = false;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.includes("slotConfig") || (req.url.includes("appointment") && req.url.includes("reschedule"))) {
      this.isAppointmentAPI = true;
    } else {
      this.isAppointmentAPI = false;
    }

    // this.spinnerService.show();
    if (req.url.indexOf("/user/checkEmail") < 0 && req.url.indexOf("/user/checkPhoneNumber") < 0 && req.url.indexOf("serviceProvider/isFieldExists") < 0 &&
      req.url.indexOf("getPaymentHistoryByTransactionId") < 0 && req.url.indexOf("getPaymentHistoryByUserEmail") < 0) {
      this.ngxService.start();
    }
    let modified = req.clone({ setParams: {} });
    if (req.url.indexOf("oauth/token") < 0 && req.url.indexOf("ForusSmartAI/eyenuk") < 0 &&
      req.url.indexOf("/password/mailtrigger") < 0 && req.url.indexOf("/password/captcha/mailtrigger") < 0 && !this.sharedService.getIsPasswordResetRequired() &&
      req.url.indexOf("/telecare") < 0 && req.url.indexOf("forus-onboarding-service") < 0 && req.url.indexOf("captcha/login") < 0) {
      //modified = req.clone({ setParams: { 'access_token': this.cookieservice.get('access_token') } });
      modified = req.clone({ setHeaders: { 'Authorization': 'Bearer ' + (this.sharedService.tokenIfCalledFromOtherApp != null ? this.sharedService.tokenIfCalledFromOtherApp : this.sharedService.getAccessToken()) } }); // adding bearer token in header
      //modified = req.clone({ setParams: { 'access_token': this.cookieservice.get('access_token') } ,setHeaders: { 'XHRF-TOKEN':this.cookieservice.get('XHRF-TOKEN')}});
    }
    else if (req.url.indexOf("/password/mailtrigger") < 0 &&
      req.url.indexOf("/password/captcha/mailtrigger") < 0 &&
      req.url.indexOf("authentication/resetPassword") > -1 &&
      this.sharedService.getIsPasswordResetRequired() &&
      req.url.indexOf("/telecare") < 0 && req.url.indexOf("forus-onboarding-service") < 0) {
      /**if password reset is required, adding token only in reset api to block the user of accessing any other api without resetting password*/
      //modified = req.clone({ setParams: { 'access_token': this.cookieservice.get('access_token') } });
      modified = req.clone({ setHeaders: { 'Authorization': 'Bearer ' + (this.sharedService.tokenIfCalledFromOtherApp != null ? this.sharedService.tokenIfCalledFromOtherApp : this.sharedService.getAccessToken()) } }); // adding bearer token in header
    }
    else if (req.url.indexOf("Logo") < 0 && req.url.indexOf("ForusSmartAI/eyenuk") < 0
      && req.url.indexOf("/password/captcha/mailtrigger") < 0
      && req.url.indexOf("forus-onboarding-service") < 0 && req.url.indexOf("captcha/login") < 0 && !this.isAppointmentAPI) {
      modified = req.clone({ setHeaders: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' } });
      //modified = req.clone({ setHeaders: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' ,'XHRF-TOKEN':this.cookieservice.get('XHRF-TOKEN')} });
    }

    if (req.url.indexOf("/telecare") >= 0 || req.url.indexOf("forus-onboarding-service") >= 0) {
      modified = req.clone({
        setHeaders: {
          'Authorization': 'Bearer ' + (this.sharedService.tokenIfCalledFromOtherApp != null ? this.sharedService.tokenIfCalledFromOtherApp : this.sharedService.getAccessToken())
        }
      });
    }

    return next.handle(modified).pipe(tap(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // this.spinnerService.hide();
          this.ngxService.stop();
        }
      },
      (err: any) => {
        // this.spinnerService.hide();
        this.ngxService.stop();
        if (req.headers.get('handleError') === 'onService') {
          // console.log('Interceptor does nothing...');
        } else {
          // console.log('onInterceptor handle ', err);
          // this.foruscareService.showNotification("Something went wrong, please try again.", "warning");
        }
        if (err.status == 0) {
          this.sharedService.removeAccessToken();
          this.router.navigate(['/login']);
          // this.foruscareService.showNotification("Logged  out successfully", "success");
        }
      }
    ));
  }
}
